import { Component, OnInit, inject } from '@angular/core';

import { UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { MatFormField, MatLabel, MatError } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-select',
  standalone: true,
  templateUrl: './select.component.html',
  styleUrls: [],
  imports: [MatFormField, ReactiveFormsModule, MatLabel, MatSelect, MatOption, MatError],
})
export class SelectComponent implements OnInit {
  private http = inject(HttpClient);

  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;
  modeSelect;
  companyHiringTypeId = localStorage.getItem('companyHiringTypeId');
  ngOnInit() {
    if (this.field && this.field.url) {
      let urlValue = this.field.url;
      if (this.field.url?.includes('{0}')) {
        urlValue = this.field.url?.replace('{0}', this.companyHiringTypeId);
      }
      this.http.get<any>(urlValue).subscribe((data) => {
        if (this.field.name == 'interviewLocation' && data) {
          this.field.options = [];
          for (const i in data) {
            const opt = {
              key: (data as Record<string, Record<string, unknown>>)[i]['cityId'],
              value: (data as Record<string, Record<string, unknown>>)[i]['cityName'],
              selected: false,
            };
            this.field?.options?.push(opt as any);
          }
          // console.log(this.field?.options,"interviewLocation");
        } else if (this.field.name == 'currentEmployer') {
          for (const i in data) {
            const opt = {
              key: (data as Record<string, Record<string, unknown>>)[i]['organizationName'],
              value: (data as Record<string, Record<string, unknown>>)[i]['organizationName'],
              selected: false,
            };
            this.field.options.push(opt as any);
          }
          console.log(this.field.options);
        }
      });
    }
    if (this.field.options && this.field.options.length !== 0) {
      // console.log(this.field.options,"inter");

      this.field.options.forEach((element) => {
        if (element.selected === true) {
          // console.log(this.field.name);
          this.modeSelect = element.key;
          // console.log("this.modeSelect--"+this.modeSelect)
          this.group.get(this.field.name).setValue(element.value);
        }
      });
    }
    if (this.field && this.field?.name == 'billingRegion') {
      this.group.get('billingRegion').valueChanges.subscribe((val) => {
        console.log(val);
        this.field.options.forEach((element) => {
          if (element.value === val) this.group.get('gstNO').setValue(element['gstNumber']);
        });
      });
    }
  }

  onchange(event) {
    // console.log("event----", event)
    this.setValidationDetails(event);
  }

  setValidation() {
    if (this.field.name == 'hiringType') {
      const event = this.group.get('hiringType').value;
      if (event === 'Regular') {
        // console.log(this.group.get('digitalOffering'));
        this.group.get('digitalOffering').clearValidators();
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalTag').clearValidators();
        this.group.get('digitalTag').updateValueAndValidity();
      } else {
        this.group.get('digitalOffering').setValidators(Validators.required);
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalTag').setValidators(Validators.required);
        this.group.get('digitalTag').updateValueAndValidity();
      }
      // console.log("data---" + this.group);
    }
  }

  setValidationDetails(event) {
    if (this.field.name == 'hiringType') {
      event = this.group.get('hiringType').value;
      if (event === 3) {
        // console.log(this.group.get('digitalOffering'));
        this.group.get('digitalOffering').clearValidators();
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalOffering').setValue('');
        this.group.get('digitalTag').clearValidators();
        this.group.get('digitalTag').updateValueAndValidity();
        this.group.get('digitalTag').setValue('');
      } else {
        this.group.get('digitalOffering').setValue('');
        this.group.get('digitalOffering').setValidators(Validators.required);
        this.group.get('digitalOffering').updateValueAndValidity();
        this.group.get('digitalTag').setValue('');
        this.group.get('digitalTag').setValidators(Validators.required);
        this.group.get('digitalTag').updateValueAndValidity();
      }
      // console.log("data---" + this.group);
    }
  }
}
